export default {

  init() {
    this.validation();
  },

  // Generic validation - do not use for Freeform forms
  validation: function() {
    var $forms = $('.js-validate');

    $forms.each(function() {
      var $form = $(this);

      $form.on('submit', function(e) {
        if($form[0].checkValidity() === false) {
          e.preventDefault();
          e.stopPropagation();

          // focus first invalid field
          var $first = $('input:invalid, select:invalid').first();
          if($first.length) {
            $first.trigger('focus');
          }

          // open all accordions
          //$form.find('.collapse').collapse('show');
        }

        $form.addClass('was-validated');
      });

      $form[0].setAttribute('novalidate', '');
    });
  },

};
